import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import config from './config.ts';
import { ai } from './infrastructure/Logging/TelemetryService';
import { StrictMode } from 'react';
import { ConfigProvider } from 'antd';
import es from 'antd/locale/es_ES';
import './styles/index.css'

// Initialize Application Insights
if (config.environment !== 'dev' && config.appInsightsConnectionString) {
    ai.initialize();
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
      <ConfigProvider locale={es}>
          <App />
      </ConfigProvider>
  </StrictMode>,
)
